import { Box, IconButton, Chip, Typography, Tabs, Tab } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface NotificationPanelHeaderProps {
  unreadCount: number;
  tabValue: number;
  onTabChange: (value: number) => void;
  onClose: () => void;
  onMarkAllAsRead: () => void;
}

export function NotificationPanelHeader({
  unreadCount,
  tabValue,
  onTabChange,
  onClose,
  onMarkAllAsRead,
}: NotificationPanelHeaderProps) {
  return (
    <>
      <Box
        sx={{
          px: 1.5,
          py: 1,
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem' }}>
            Notifications
          </Typography>
          {unreadCount > 0 && (
            <Chip
              label={unreadCount}
              size="small"
              color="primary"
              sx={{ height: 18, fontSize: '0.68rem', fontWeight: 700, '& .MuiChip-label': { px: 0.7 } }}
            />
          )}
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ p: 0.4 }}>
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={(_, v) => onTabChange(v)}
          sx={{ minHeight: 36, '& .MuiTab-root': { minHeight: 36, py: 0.5, fontSize: '0.72rem' } }}
        >
          <Tab label={`NON LUES (${unreadCount})`} />
          <Tab label="TOUTES" />
        </Tabs>

        {unreadCount > 0 && tabValue === 0 && (
          <Box sx={{ px: 1.5, py: 0.6, borderBottom: 1, borderColor: 'divider' }}>
            <Typography
              variant="caption"
              onClick={onMarkAllAsRead}
              sx={{ fontSize: '0.72rem', cursor: 'pointer', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}
            >
              Marquer tout comme lu
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
}
